import * as React from 'react';
import { Tooltip } from '@iba-team/portal-react-components/dist';
import JobSearchIcon from '../../assets/icons/leaveTypes/job-search.svg';

export const JobSearchCell = () => <div className={'default_cell_container'}>
  <div className={'drag_container'}>
    <Tooltip title={'Job Search'}>
      <img src={JobSearchIcon} alt={'jobSearch'}/>
    </Tooltip>
  </div>
</div>;